<template>
  <detail
    :on-manager="onManager"
    :data="resultData"
    :base-info="baseInfo"
    resource="customers"
    :nameProps="{ edit: false }" />

</template>

<script>
import paperworkFile from '../components/paperworkFile'
import consts from '@scope/constants/consts'

export default {
  name: 'TenantDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      enterpriseInfo: {},
      cityOps: [],
      addressDesc: '',
      unitTypes: {
        business: this.$t('scope.text_605'),
        institution: this.$t('scope.text_609'),
      },
    }
  },
  computed: {
    resultData () {
      return {
        ...this.enterpriseInfo,
        id: this.data.id,
        customerId: this.enterpriseInfo.id,
        addressDesc: this.addressDesc,
        enterprise_name: this.data.enterprise_name,
        mobile: this.data.mobile,
        concat: this.data.name,
        project_domain: this.data.project_domain,
        description: this.data.description,
        customer_level: this.data.customer_level,
      }
    },
    baseInfo () {
      return [
        {
          field: 'customer_level',
          title: '用户等级',
          minWidth: 80,
          formatter: ({ cellValue }) => {
            if (cellValue in consts.customerLevelMap) return consts.customerLevelMap[cellValue]
            return '-'
          },
        },
        {
          field: 'concat',
          title: this.$t('scope.text_322'),
        },
        {
          field: 'mobile',
          title: this.$t('scope.text_494'),
        },
        {
          field: 'license_number',
          title: this.$t('scope.text_588'),
        },
        {
          field: 'licenseType',
          title: this.unitTypes[this.enterpriseInfo.license_type],
          slots: {
            default: ({ row }, h) => {
              const ret = [
                <a-tooltip>
                  <template slot="title">
                    {this.unitTypes[this.enterpriseInfo.license_type]}
                  </template>
                  <a-icon type="file-image" onClick={ () => this.viewImage('credentials') } class="imageIcon" />
                </a-tooltip>,
              ]
              return ret
            },
          },
        },
        {
          field: 'country',
          title: this.$t('scope.text_591'),
          formatter: () => {
            return this.$t('scope.text_601')
          },
        },
        {
          field: 'company_type',
          title: '企业类型',
        },
        {
          field: 'reg_address',
          title: '注册地址',
        },
        {
          field: 'registered_capital',
          title: '注册资本',
        },
        {
          field: 'registered_date',
          title: '注册时间',
        },
        {
          field: 'issue_date',
          title: '发证时间',
        },
        {
          field: 'postcode',
          title: this.$t('scope.text_594'),
        },
        {
          field: 'legal_person',
          title: '法人姓名',
        },
        /* {
          field: 'idCard',
          title: this.$t('scope.text_617'),
          slots: {
            default: ({ row }, h) => {
              const ret = [
                <a-tooltip>
                  <template slot="title">{ this.$t('scope.text_919') }</template>
                  <a-icon type="file-image" onClick={ () => this.viewImage('indentiycard-a') } class="mr-2 imageIcon" />
                </a-tooltip>,
                <a-tooltip>
                  <template slot="title">{ this.$t('scope.text_920') }</template>
                  <a-icon type="file-image" onClick={ () => this.viewImage('indentiycard-b') } class="imageIcon" />
                </a-tooltip>,
              ]
              return ret
            },
          },
        }, */
        {
          field: 'created_at',
          title: this.$t('scope.text_498'),
          formatter: ({ row }) => {
            return (row.created_at && this.$moment(row.created_at).format()) || '-'
          },
        },
      ]
    },
  },
  created () {
    this.manager = new this.$Manager('customers')
    this.fetchEnterPriseInfo()
  },
  destroyed () {
    this.manager = null
  },
  methods: {
    fetchEnterPriseInfo () {
      this.manager.getSpecific({ id: this.data.id, spec: 'enterprise-info' }).then(res => {
        this.enterpriseInfo = res.data
        this.addressDesc = ''
        this.enterpriseInfo.addressCode = []
        this.fetchCities()
      })
    },
    deepTraversal (val, list) {
      let desc = ''
      if (val) {
        const valPrefix = val.slice(0, 3)
        list.map(item => {
          const itemPrefix = item.value.slice(0, 3)
          if (valPrefix === itemPrefix && item.children && item.children.length) {
            item.children.map(chilItem => {
              if (val === chilItem.value) {
                this.addressDesc = item.label + chilItem.label
                desc = item.label + chilItem.label
                this.enterpriseInfo.addressCode.push(item.value)
                this.enterpriseInfo.addressCode.push(chilItem.value)
              }
            })
          }
        })
      }
      return desc
    },
    async fetchCities () {
      const { data } = await this.$http.get('/v2/cities?nation_code=CN')
      this.cityOps = data.data
      this.deepTraversal(this.enterpriseInfo.reg_address, this.cityOps)
    },
    async viewImage (type) {
      const id = this.data.id
      this.$info({
        title: this.$t('scope.text_921'),
        okText: this.$t('scope.text_922'),
        width: 600,
        content (h) {
          return [
            <paperworkFile type={type} id={id} />,
          ]
        },
        onOk () {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
  ::v-deep .imageIcon{
    font-size: 16px;
    cursor: pointer;
    color: #1890ff;
  }
</style>
